export function InstagramIcon({ className }: { className?: string }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" className={className} role="img" viewBox="0 0 24 24">
			<title>Instagram</title>
			<path d="M7.03.084c-1.277.06-2.149.264-2.91.563a5.9 5.9 0 0 0-2.124 1.388 5.9 5.9 0 0 0-1.38 2.127C.321 4.926.12 5.8.064 7.076s-.069 1.688-.063 4.947.021 3.667.083 4.947c.061 1.277.264 2.149.563 2.911.308.789.72 1.457 1.388 2.123a5.9 5.9 0 0 0 2.129 1.38c.763.295 1.636.496 2.913.552 1.278.056 1.689.069 4.947.063s3.668-.021 4.947-.082c1.28-.06 2.147-.265 2.91-.563a5.9 5.9 0 0 0 2.123-1.388 5.9 5.9 0 0 0 1.38-2.129c.295-.763.496-1.636.551-2.912.056-1.28.07-1.69.063-4.948-.006-3.258-.02-3.667-.081-4.947-.06-1.28-.264-2.148-.564-2.911a5.9 5.9 0 0 0-1.387-2.123 5.9 5.9 0 0 0-2.128-1.38c-.764-.294-1.636-.496-2.914-.55C15.647.009 15.236-.006 11.977 0S8.31.021 7.03.084m.14 21.693c-1.17-.05-1.805-.245-2.228-.408a3.7 3.7 0 0 1-1.382-.895 3.7 3.7 0 0 1-.9-1.378c-.165-.423-.363-1.058-.417-2.228-.06-1.264-.072-1.644-.08-4.848-.006-3.204.006-3.583.061-4.848.05-1.169.246-1.805.408-2.228.216-.561.477-.96.895-1.382a3.7 3.7 0 0 1 1.379-.9c.423-.165 1.057-.361 2.227-.417 1.265-.06 1.644-.072 4.848-.08 3.203-.006 3.583.006 4.85.062 1.168.05 1.804.244 2.227.408.56.216.96.475 1.382.895s.681.817.9 1.378c.165.422.362 1.056.417 2.227.06 1.265.074 1.645.08 4.848.005 3.203-.006 3.583-.061 4.848-.051 1.17-.245 1.805-.408 2.23-.216.56-.477.96-.896 1.38a3.7 3.7 0 0 1-1.378.9c-.422.165-1.058.362-2.226.418-1.266.06-1.645.072-4.85.079s-3.582-.006-4.848-.06m9.783-16.192a1.44 1.44 0 1 0 1.437-1.442 1.44 1.44 0 0 0-1.437 1.442M5.839 12.012a6.161 6.161 0 1 0 12.323-.024 6.162 6.162 0 0 0-12.323.024M8 12.008A4 4 0 1 1 12.008 16 4 4 0 0 1 8 12.008" />
		</svg>
	);
}

export function XSocialIcon({ className }: { className?: string }) {
	return (
		<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className}>
			<title>X</title>
			<path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"></path>
		</svg>
	);
}

export function FacebookIcon({ className }: { className?: string }) {
	return (
		<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className}>
			<title>Facebook</title>
			<path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z"></path>
		</svg>
	);
}

export function QuoteIcon({ width = 46, height = 28 }: { width?: number; height?: number }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" height={height} width={width} viewBox="0 0 46 28">
			<path
				fill="currentColor"
				d="M10.727 28q-4.773 0-7.636-2.8Q.227 22.333.227 17.467.227 13 2.41 8.8q2.25-4.266 6.273-7.467l3.954 3.734q-2.385 2.133-3.75 4.4-1.294 2.2-1.704 4.266a6.6 6.6 0 0 1 1.909-.266q3.273 0 5.318 2.066 2.115 2.001 2.114 5.267 0 3.267-2.318 5.333C12.705 27.378 10.863 28 10.682 28zm19.455 0q-4.773 0-7.636-2.8-2.864-2.867-2.864-7.733 0-4.467 2.182-8.667 2.25-4.266 6.272-7.467l3.955 3.734q-2.387 2.133-3.75 4.4-1.296 2.2-1.705 4.266a6.6 6.6 0 0 1 1.91-.266q3.272 0 5.318 2.066 2.113 2.001 2.113 5.267t-2.318 5.333C32.16 27.378 30.32 28 30.136 28z"
			/>
		</svg>
	);
}

export function DetailsIcon({ className }: { className?: string }) {
	return (
		<svg
			width="60"
			height="44"
			viewBox="0 0 60 44"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<g clipPath="url(#clip0_522_337)">
				<path
					d="M47.4534 18.8118H41.7676C40.8435 18.8118 39.9493 19.1326 39.2391 19.723L35.6068 22.735C34.8966 23.3254 34.0025 23.6462 33.0784 23.6462H28.415C27.1487 23.6462 25.955 24.2537 25.2106 25.2763L24.1196 26.7737"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M34.9352 30.4787C34.563 30.3546 22.2672 29.7984 19.144 29.6572C18.6734 29.6358 18.2114 29.5118 17.7964 29.2936L6.16371 23.1927C4.78182 22.4697 3.08334 22.8376 2.12501 24.0655C0.905695 25.6356 1.38486 27.9245 3.1304 28.8743L23.8587 40.1176C24.5732 40.507 25.4074 40.6096 26.1946 40.4043C29.9424 39.4374 41.2029 36.5966 44.0394 36.5966H47.4534"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M58.1235 13.2627H54.8891C53.1393 13.2627 51.7231 14.6788 51.7231 16.4286V39.403C51.7231 41.1528 53.1393 42.569 54.8891 42.569H58.5513"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M17.4753 2.63988C17.7534 2.63988 18.0187 2.55003 18.2326 2.37462C18.9299 1.80561 20.8423 0.594854 23.6318 1.59597C27.0458 2.82384 30.4599 8.99313 25.1976 13.6907C22.1386 16.4202 20.4059 17.9176 19.4947 18.6877C18.9299 19.1669 18.2155 19.4279 17.4753 19.4279C16.7352 19.4279 16.0207 19.1669 15.456 18.6877C14.5447 17.9134 12.812 16.4202 9.75301 13.6907C4.49072 8.99741 7.90479 2.82812 11.3189 1.59597C14.1083 0.590576 16.0207 1.80133 16.7181 2.37462C16.932 2.55003 17.2015 2.63988 17.4753 2.63988Z"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_522_337">
					<rect width="59.5324" height="43.784" fill="white" transform="translate(0.233887)" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function ImagesIcon({ className }: { className?: string }) {
	return (
		<svg
			width="52"
			height="45"
			viewBox="0 0 52 45"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<g clipPath="url(#clip0_522_346)">
				<path
					d="M44.7944 33.6145C43.6264 34.7825 43.4938 36.635 44.4864 37.957L44.7944 38.3677"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M44.7944 20.0396C43.6264 21.2075 43.4938 23.06 44.4864 24.382L44.7944 24.7927"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M44.7944 5.46753C43.6264 6.6355 43.4938 8.488 44.4864 9.80999L44.7944 10.2207"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M16.9644 11.2175H30.5394V34.2946L23.754 28.1852L16.9644 34.2946V11.2175Z"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M50.2236 29.5459H30.7788"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M16.562 29.5459H8.76268C4.90367 29.5459 1.78052 32.6733 1.78052 36.5281C1.78052 40.3828 4.90794 43.5102 8.76268 43.5102H50.2278"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M50.2236 15.2905H30.7788"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M16.562 15.2905H8.76268C4.90367 15.2905 1.78052 18.418 1.78052 22.2727C1.78052 26.1274 4.90794 29.2549 8.76268 29.2549H16.562"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M50.2237 1.33472H8.75853C4.90379 1.33472 1.77637 4.46214 1.77637 8.31688C1.77637 12.1716 4.90379 15.299 8.75853 15.299H16.284"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_522_346">
					<rect width="51.117" height="44.845" fill="white" transform="translate(0.441406)" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function BreakdownIcon({ className }: { className?: string }) {
	return (
		<svg
			width="60"
			height="58"
			viewBox="0 0 60 58"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<g clipPath="url(#clip0_522_291)">
				<path
					d="M56.1255 21.862C56.0998 21.7593 56.0784 21.6566 56.0485 21.5539C52.1381 6.92648 37.1042 -1.76273 22.4768 2.15191C7.84933 6.06226 -0.839874 21.0919 3.07476 35.7236C6.98511 50.3511 22.019 59.0403 36.6465 55.1256C45.4084 52.7811 52.0355 46.4493 55.103 38.6029"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M38.6658 21.9347C40.1846 23.1284 41.0873 24.6343 41.0873 26.2686C41.0873 30.1576 35.9577 33.3107 29.6344 33.3107C23.3111 33.3107 18.1814 30.1576 18.1814 26.2686C18.1814 22.3797 23.3111 19.2266 29.6344 19.2266C31.8291 19.2266 33.8784 19.6073 35.6197 20.2619"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.1815 25.7681L18.0531 33.8284C18.0446 34.5428 18.4296 35.1503 18.8959 35.6894C23.5293 41.033 35.6797 41.4223 40.3302 36.0402C40.7965 35.5012 41.2072 34.9108 41.2158 34.2006L41.0874 26.2686"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M22.8105 32.4978V36.9558"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M27.5723 38.7141V33.593"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M32.458 39.2361V33.4048"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M36.9631 32.4551V37.1526"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M57.8667 43.9207L56.2024 36.9771L49.2588 38.6413"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_522_291">
					<rect width="58.1547" height="57.2777" fill="white" transform="translate(0.922607)" />
				</clipPath>
			</defs>
		</svg>
	);
}
